var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.41 2.012c-.648.09-1.203.626-1.367 1.318C4.001 3.51 4 3.63 4 12c0 8.372 0 8.49.043 8.671.234.99 1.191 1.559 2.087 1.24a4 4 0 0 0 .528-.28c1.904-1.15 13.606-8.271 13.701-8.337.308-.213.547-.589.615-.97a1.85 1.85 0 0 0-.08-.924 1.55 1.55 0 0 0-.536-.694c-.179-.124-13.873-8.445-14.055-8.54a1.6 1.6 0 0 0-.894-.154m-.002.959c-.258.1-.447.367-.488.687-.028.227-.028 16.459 0 16.686.041.323.232.588.494.688a.5.5 0 0 0 .393.005c.124-.044 14.007-8.476 14.104-8.566.113-.105.166-.256.166-.47s-.053-.365-.166-.47c-.088-.082-13.97-8.517-14.099-8.567a.53.53 0 0 0-.404.007",
    clipRule: "evenodd"
  })));
};
export default SvgPlay;